module.exports = __webpack_public_path__ + "static/media/eth-diamond-plain.cbd22789.svg";